<template>
  <a-modal
          :title="bigtitle"
          okText="确认"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model v-if="!param.disabled" ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="12">
          <a-form-model-item  label="机构代码" prop="code">
            <a-input v-model="formState.code"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="检测机构名称" prop="name">
            <a-input v-model="formState.name"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="检测机构类型" prop="type">
            <a-ext-local-dic-select dicKey="CheckerType" v-model="formState.type"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="社会信用代码" prop="publicCode">
            <a-input v-model="formState.publicCode"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="所属区域" prop="xzqh">
            <a-ext-dist-picker-qu v-model="formState.xzqh"></a-ext-dist-picker-qu>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="机构联系方式" prop="orgTel">
            <a-input v-model="formState.orgTel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="法定代表人" prop="bossName">
            <a-input v-model="formState.bossName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="法人身份证" prop="bossCode">
            <a-input v-model="formState.bossCode"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="机构所在地址" prop="address">
            <a-input v-model="formState.address"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="电子邮箱" prop="email">
            <a-input v-model="formState.email"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="传真" prop="fax">
            <a-input v-model="formState.fax"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="邮编" prop="mailCode">
            <a-input v-model="formState.mailCode"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="负责人" prop="ceoName">
            <a-input v-model="formState.ceoName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="负责人电话" prop="ceoTel">
            <a-input v-model="formState.ceoTel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="联系人" prop="connectName">
            <a-input v-model="formState.connectName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="联系人电话" prop="connectTel">
            <a-input v-model="formState.connectTel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="质量负责人" prop="qaName">
            <a-input v-model="formState.qaName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="质量负责人电话" prop="qaTel">
            <a-input v-model="formState.qaTel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item  label="质量认定证书" prop="jlrdzs">
            <a-ext-upload v-model="formState.jlrdzs"></a-ext-upload>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item  label="机构考核证书" prop="jgkhzs">
            <a-ext-upload v-model="formState.jgkhzs"></a-ext-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>
    <a-form-model v-else :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
    <a-row>
      <a-col span="12">
        <a-form-model-item  label="机构代码" prop="code">
          <a-ext-bold-a v-model="formState.code"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="检测机构名称" prop="name">
          <a-ext-bold-a v-model="formState.name"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="检测机构类型" prop="type">
          <a-ext-bold-a v-model="formState.type"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="社会信用代码" prop="publicCode">
          <a-ext-bold-a v-model="formState.publicCode"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="所属区域" prop="xzqh">
          <a-ext-bold-a :value="formState.regionName"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="机构联系方式" prop="orgTel">
          <a-ext-bold-a v-model="formState.orgTel"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="法定代表人" prop="bossName">
          <a-ext-bold-a v-model="formState.bossName"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="法人身份证" prop="bossCode">
          <a-ext-bold-a v-model="formState.bossCode"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="24">
        <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="机构所在地址" prop="address">
          <a-ext-bold-a v-model="formState.address"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="电子邮箱" prop="email">
          <a-ext-bold-a v-model="formState.email"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="传真" prop="fax">
          <a-ext-bold-a v-model="formState.fax"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="24">
        <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="邮编" prop="mailCode">
          <a-ext-bold-a v-model="formState.mailCode"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="负责人" prop="ceoName">
          <a-ext-bold-a v-model="formState.ceoName"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="负责人电话" prop="ceoTel">
          <a-ext-bold-a v-model="formState.ceoTel"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="联系人" prop="connectName">
          <a-ext-bold-a v-model="formState.connectName"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="联系人电话" prop="connectTel">
          <a-ext-bold-a v-model="formState.connectTel"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="质量负责人" prop="qaName">
          <a-ext-bold-a v-model="formState.qaName"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="质量负责人电话" prop="qaTel">
          <a-ext-bold-a v-model="formState.qaTel"></a-ext-bold-a>
        </a-form-model-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col span="12">
        <a-form-model-item  label="质量认定证书" prop="jlrdzs">
          <a-ext-upload :disabled="param.disabled" v-model="formState.jlrdzs"></a-ext-upload>
        </a-form-model-item>
      </a-col>

      <a-col span="12">
        <a-form-model-item  label="机构考核证书" prop="jgkhzs">
          <a-ext-upload :disabled="param.disabled" v-model="formState.jgkhzs"></a-ext-upload>
        </a-form-model-item>
      </a-col>
    </a-row>

    </a-form-model>
  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtDistPickerQu from '../../../components/AntDesignExt/All/AExtDistPickerQu'
import AExtBoldA from '../../../components/AntDesignExt/All/AExtBoldA'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import {addorUpdateOChecker as saveApi,getOCheckerById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtLocalDicSelect,AExtDistPickerQu,AExtUpload,AExtBoldA},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                code:'',
                name:'',
                type:'',
                public_code:'',
                xzqh:'',
                org_tel:'',
                boss_name:'',
                boss_code:'',
                address:'',
                email:'',
                fax:'',
                mail_code:'',
                ceo_name:'',
                ceo_tel:'',
                connect_name:'',
                connect_tel:'',
                qa_name:'',
                qa_tel:'',
                jlrdzs:'',
                jgkhzs:'',
            },
            rules: {
                code: FormRules.withName('机构代码').string(1, 50).isRequired().create(),
                name: FormRules.withName('检测机构名称').string(1, 200).isRequired().create(),
                type: FormRules.withName('检测机构类型').string(1, 50).isRequired().create(),
                publicCode: FormRules.withName('社会信用代码').string(1, 50).isRequired().create(),
                xzqh: FormRules.withName('所属区域').string(1, 50).isRequired().create(),
                orgTel: FormRules.withName('机构联系方式').string(7, 50).isRequired().create(),
                bossName: FormRules.withName('法定代表人').string(1, 50).isRequired().create(),
                bossCode: FormRules.withName('法人身份证').identityCard().isRequired().create(),
                address: FormRules.withName('机构所在地址').string(1, 200).isRequired().create(),
                ceoName: FormRules.withName('负责人').string(1, 50).isRequired().create(),
                ceoTel: FormRules.withName('负责人电话').string(1, 50).isRequired().create(),
                connectName: FormRules.withName('联系人').string(1, 50).isRequired().create(),
                connectTel: FormRules.withName('联系人电话').string(1, 50).isRequired().create(),
                qaName: FormRules.withName('质量负责人').string(1, 50).isRequired().create(),
                qaTel: FormRules.withName('质量负责人电话').string(1, 50).isRequired().create(),
                jlrdzs: FormRules.withName('质量认定证书').callback((value, field) => {
                    if (!value.name) {
                        return new Error('需要上传计量认定证书');
                    }
                }).create(),
                jgkhzs: FormRules.withName('机构考核证书').callback((value, field) => {
                    if (!value.name) {
                        return new Error('需要上传机构考核证书');
                    }
                }).create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi({id:this.param.id}).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                    if(this.$refs.ruleForm)
                    this.$refs.ruleForm.clearValidate()

                })).catch(() => {
                    this.confirmLoading = false;
                    if(this.$refs.ruleForm)
                    this.$refs.ruleForm.clearValidate()
                });
                if(this.param.disabled===false)
                {
                    this.bigtitle='检测机构信息编辑';
                }
                else {
                    this.bigtitle='监测机构详情';
                }
            }
            else {
                this.bigtitle='新增监测机构';
                this.$refs.ruleForm.clearValidate()
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("addOCheckerClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>